var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommitmentToServe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 491.467,
    height: 426.287,
    viewBox: "0 0 491.467 426.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.36,
    y1: 0.187,
    x2: 14.189,
    y2: 0.804,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd3a7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.067,
    x2: 0,
    y2: 0.808,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.149,
    y1: 0.383,
    x2: 0.825,
    y2: 0.655,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.792,
    y1: 0.359,
    x2: 1,
    y2: 1.096,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.426,
    y1: -0.075,
    x2: 1.46,
    y2: 1.647,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.616,
    y1: 0.564,
    x2: 0,
    y2: 0.557,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12355f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.573,
    y1: 0.56,
    x2: 0.5,
    y2: -0.761,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#134270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.008,
    y1: 0.482,
    x2: 1.007,
    y2: 0.518,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0,
    y1: 0.47,
    x2: 1,
    y2: 0.53,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.274,
    y1: 0.704,
    x2: 0.527,
    y2: 1.075,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.387,
    y1: 0.635,
    x2: 0.306,
    y2: -0.616,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.638,
    y1: 0.718,
    x2: 1.564,
    y2: 1.817,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -1.116,
    y1: 1.923,
    x2: -0.09,
    y2: 1.923,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.147,
    y1: 0.878,
    x2: 0.86,
    y2: 0.055,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#242a70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#19154e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.346,
    y1: 1.12,
    x2: 0.381,
    y2: 0.246,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150e42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.432,
    y1: 0.614,
    x2: 0.539,
    y2: 2.075,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12355f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -0.164,
    y1: 1.457,
    x2: 0.832,
    y2: 1.457,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.794,
    y1: 0.362,
    x2: -0.036,
    y2: 1.083,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.694,
    y1: -0.285,
    x2: 0.083,
    y2: 1.9,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1.356,
    y1: 0.082,
    x2: -0.277,
    y2: 1.029,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.969,
    y1: 0.029,
    x2: -0.198,
    y2: 1.417,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 0.487,
    y1: -1.67,
    x2: 0.501,
    y2: 0.95,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 1.455,
    y1: 0.139,
    x2: -0.159,
    y2: 0.83,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 2.64,
    y1: -9.106,
    x2: 3.704,
    y2: -9.106,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 8.932,
    y1: -42.133,
    x2: 12.14,
    y2: -44.54,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -0.577,
    y1: 0.518,
    x2: 3.981,
    y2: 0.409,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.541,
    y1: 0.163,
    x2: 0.558,
    y2: 1.251,
    xlinkHref: "#linear-gradient-22"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -0.167,
    y1: 5.532,
    x2: -0.954,
    y2: 8.487,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 1.814,
    y1: 2.499,
    x2: -1.802,
    y2: -3.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd3a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 1.686,
    y1: 1.515,
    x2: -1.379,
    y2: -0.807,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.914,
    y1: 0.444,
    x2: -0.586,
    y2: 0.647,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#53d8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840f7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -0.003,
    y1: 4.629,
    x2: 0.698,
    y2: -1.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#12355f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.887,
    y1: -0.13,
    x2: 0.184,
    y2: 1.066,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 0.383,
    y1: 0.498,
    x2: 4.218,
    y2: 0.546,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0.631,
    y1: 3.007,
    x2: 1.06,
    y2: 10.502,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.487,
    y1: -9.818,
    x2: 0.501,
    y2: 1.773,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 0.015,
    y1: 0.504,
    x2: 2.308,
    y2: 0.486,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 0.659,
    y1: 1.294,
    x2: 0.351,
    y2: -0.18,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 0.546,
    y1: 1.957,
    x2: 0.675,
    y2: 4.709,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 0.603,
    y1: -1.221,
    x2: 0.457,
    y2: 1.223,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -0.003,
    y1: 4.629,
    x2: 0.698,
    y2: -1.005,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 0.094,
    y1: 0.973,
    x2: 1.015,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134270"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 0.447,
    y1: 0.5,
    x2: 2.777,
    y2: 0.5,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 0.913,
    y1: 0.451,
    x2: -0.586,
    y2: 0.581,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 0.443,
    y1: 1.318,
    x2: 1.118,
    y2: -5.751,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 0.435,
    y1: 0.556,
    x2: 1.967,
    y2: -0.323,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#12355f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12355f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 0.734,
    y1: 0.095,
    x2: -0.216,
    y2: 1.864,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.235,
    stopColor: "#134270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12355f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 0.528,
    y1: 0.24,
    x2: 0.667,
    y2: 1.178,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#125082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 0.104,
    y1: 11.789,
    x2: -0.709,
    y2: 14.921,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 0.538,
    y1: -0.551,
    x2: 0.47,
    y2: 0.962,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 3.118,
    y1: 13.227,
    x2: 3.807,
    y2: 14.481,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 25.833,
    y1: 37.536,
    x2: 20.168,
    y2: 39.83,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -0.181,
    y1: 1.029,
    x2: 0.887,
    y2: 0.212,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f48a21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 0.858,
    y1: 0.314,
    x2: 0.871,
    y2: 1.364,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID",
    d: "M778.413,1020.117a.771.771,0,0,1-.771.771h-2.055a.771.771,0,0,1-.771-.771h0a.771.771,0,0,1,.771-.771h2.055a.771.771,0,0,1,.771.771Z",
    transform: "translate(-774.816 -1019.346)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 2.408,
    y1: 0.127,
    x2: -3.229,
    y2: 1.189,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 0.376,
    y1: 0.969,
    x2: 1.205,
    y2: -2.088,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 0.362,
    y1: 1.983,
    x2: 0.571,
    y2: -0.144,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb265"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 1.814,
    y1: 2.499,
    x2: -1.802,
    y2: -3.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1473d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9605a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 1.686,
    y1: 1.515,
    x2: -1.379,
    y2: -0.807,
    xlinkHref: "#linear-gradient-220"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 0.454,
    y1: 0.5,
    x2: 1.348,
    y2: -0.353,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#125082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12355f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 0.03,
    y1: 0.044,
    x2: 1,
    y2: 1.388,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1.346,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 1.334,
    y1: 0.401,
    x2: 0.506,
    y2: 0.501,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 0.549,
    y1: 1.313,
    x2: 1.079,
    y2: -0.087,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 0.913,
    y1: 0.451,
    x2: -0.586,
    y2: 0.581,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 0.469,
    y1: -0.548,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 0.934,
    y1: 0.27,
    x2: 2.465,
    y2: -0.609,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 0.576,
    y1: 1.016,
    x2: 0.412,
    y2: -0.429,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 0.5,
    y1: -0.936,
    x2: 0.5,
    y2: 0.618,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 0.507,
    y1: -0.343,
    x2: 0.5,
    y2: 1.699,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 0.128,
    y1: 0.126,
    x2: 0.5,
    y2: 0.721,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 0.537,
    y1: 0.298,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 1.944,
    y1: 2.489,
    x2: -4.349,
    y2: 3.457,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 0.537,
    y1: 1.353,
    x2: 0.591,
    y2: 2.585,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f48a21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4f52ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 0.628,
    y1: -0.468,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 0.327,
    y1: -0.749,
    x2: 0.538,
    y2: 0.731,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 0.555,
    y1: -0.008,
    x2: 0.425,
    y2: 1.006,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 1.286,
    y1: 2.058,
    x2: -0.186,
    y2: -0.895,
    xlinkHref: "#linear-gradient-23"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 0.639,
    y1: 0.731,
    x2: 0.94,
    y2: 0.938,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-2",
    "data-name": "SVGID",
    d: "M1629.353,1019.3a.77.77,0,0,1-.821.717l-2.051-.137a.771.771,0,0,1-.718-.821h0a.771.771,0,0,1,.821-.717l2.051.137a.771.771,0,0,1,.718.821Z",
    transform: "translate(-1625.763 -1018.344)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-397",
    x1: 2.515,
    y1: -1.496,
    x2: -2.849,
    y2: -0.394,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-398",
    x1: 0.37,
    y1: 0.949,
    x2: 0.971,
    y2: -1.143,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-399",
    x1: 0.187,
    y1: 1.072,
    x2: 1.1,
    y2: -0.459,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-400",
    x1: 0.537,
    y1: -0.027,
    x2: 0.564,
    y2: 1.106,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-401",
    x1: -0.405,
    y1: -3.322,
    x2: 0.485,
    y2: 0.454,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-402",
    x1: -4.954,
    y1: 3.295,
    x2: -3.43,
    y2: 0.988,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-403",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-404",
    x1: -38.586,
    y1: 4.381,
    x2: -33.674,
    y2: 0.665,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-405",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "commitment-to-serve",
    transform: "translate(-504.956 -208.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10787",
    "data-name": "Group 10787",
    transform: "translate(607.185 208.995)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10781",
    "data-name": "Group 10781",
    transform: "translate(42.887 33.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M950.774,380.289l-6.212-.253c.074-1.831,2.131-45.134,28.922-71.013l4.319,4.471C952.785,337.661,950.791,379.865,950.774,380.289Z",
    transform: "translate(-944.562 -309.023)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10782",
    "data-name": "Group 10782",
    transform: "translate(203.49 33.02)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    "data-name": "Path 3024",
    d: "M1458.11,380.289l6.212-.253c-.074-1.831-2.131-45.134-28.922-71.013l-4.319,4.471C1456.1,337.661,1458.093,379.865,1458.11,380.289Z",
    transform: "translate(-1431.081 -309.023)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    "data-name": "Path 3025",
    d: "M1159.089,254.841c-2.189,2.42-5.883,1.867-8.392-.961-37.648-42.578-96.5-42.578-134.148,0-2.509,2.829-6.2,3.381-8.392.961h0c-2.186-2.412-1.786-7.214,1.05-10.418,41.769-47.238,107.062-47.238,148.831,0,2.836,3.2,3.236,8.005,1.05,10.418Z",
    transform: "translate(-943.341 -208.995)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10783",
    "data-name": "Group 10783",
    transform: "translate(213.612 74.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M1533.409,434.84a1.981,1.981,0,0,1,2.342.972l9.076,13.9a26.309,26.309,0,0,1,4.312,13.955V476.3s12.233,9.5,12.233,23.313-8.476,32.466-19.182,35.574c-.579,1.273-1.154,2.333-1.555,3.215a5.75,5.75,0,0,1-6.321,3.593l-2.095-.418V437.039C1532.219,436.021,1532.431,435.124,1533.409,434.84Z",
    transform: "translate(-1508.954 -434.749)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1653",
    "data-name": "Rectangle 1653",
    width: 23.265,
    height: 101.518,
    rx: 11.632,
    transform: "translate(0 17.436)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10786",
    "data-name": "Group 10786",
    transform: "translate(0 75.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10784",
    "data-name": "Group 10784",
    transform: "translate(5.56 67.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    "data-name": "Path 3027",
    d: "M948.518,727.468c-1.758-.043-43.477-1.223-80.365-16.29C852.2,704.66,840.8,690.815,835.19,671.138a96.713,96.713,0,0,1-3.678-27.727l6.211.259-3.106-.129,3.106.127a92.141,92.141,0,0,0,3.492,25.93c5.154,17.939,15.008,29.992,29.288,35.825,35.8,14.624,77.747,15.82,78.166,15.831Z",
    transform: "translate(-831.486 -643.411)",
    fill: "url(#linear-gradient-8)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1654",
    "data-name": "Rectangle 1654",
    width: 40.889,
    height: 16.92,
    rx: 8.46,
    transform: "translate(120.553 139.773)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1655",
    "data-name": "Rectangle 1655",
    width: 28.2,
    height: 16.92,
    rx: 8.46,
    transform: "translate(0 60.109)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10785",
    "data-name": "Group 10785",
    transform: "translate(13.589)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M883.771,437.979a2.154,2.154,0,0,0-2.473.972l-8.879,13.9A26.1,26.1,0,0,0,868.3,466.8V479.44s-12.5,9.5-12.5,23.313,8.345,32.466,19.051,35.574c.579,1.273,1.088,2.333,1.489,3.215a6.035,6.035,0,0,0,6.551,3.593l2.324-.419V440.178A2.124,2.124,0,0,0,883.771,437.979Z",
    transform: "translate(-855.808 -437.888)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1656",
    "data-name": "Rectangle 1656",
    width: 23.265,
    height: 101.518,
    rx: 11.632,
    transform: "translate(29.415 17.81)",
    fill: "url(#linear-gradient-12)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10836",
    "data-name": "Group 10836",
    transform: "translate(504.956 443.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10788",
    "data-name": "Group 10788",
    transform: "translate(16.917 33.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    "data-name": "Path 3029",
    d: "M633.814,1091.385l-39.363,3.957L576,1097.193l-19.347-60.324a9.546,9.546,0,0,1,2.8-10.083l2.807-2.457a9.755,9.755,0,0,1,2.288-1.482,8.958,8.958,0,0,1,2.113-.681c.063-.019.094-.025.094-.025.025-.006.044-.253.069-.259a9.592,9.592,0,0,1,1.713-.4h38.288a9.768,9.768,0,0,1,9.171,7.167Z",
    transform: "translate(-556.202 -1021.479)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M594.45,1096.606,576,1098.457l-19.347-60.324a9.546,9.546,0,0,1,2.8-10.083l2.807-2.457a9.753,9.753,0,0,1,2.288-1.482c1.081-.369,1.857-.6,2.113-.681.063-.019.094-.025.094-.025.025-.006.044-.006.069-.013C576.828,1021.861,591.769,1084.922,594.45,1096.606Z",
    transform: "translate(-556.202 -1022.742)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10789",
    "data-name": "Group 10789",
    transform: "translate(170.07 33.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M1097.766,1091.385l-39.363,3.957-18.447,1.85-19.347-60.324a9.547,9.547,0,0,1,2.8-10.083l2.807-2.457a9.757,9.757,0,0,1,2.288-1.482,8.957,8.957,0,0,1,2.113-.681c.062-.019.094-.025.094-.025.025-.006.044-.253.069-.259a9.591,9.591,0,0,1,1.713-.4h38.288a9.767,9.767,0,0,1,9.17,7.167Z",
    transform: "translate(-1020.155 -1021.479)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M1058.4,1096.606l-18.447,1.85-19.347-60.324a9.547,9.547,0,0,1,2.8-10.083l2.807-2.457a9.756,9.756,0,0,1,2.288-1.482c1.081-.369,1.857-.6,2.113-.681.062-.019.094-.025.094-.025.025-.006.044-.006.069-.013C1040.781,1021.861,1055.721,1084.922,1058.4,1096.606Z",
    transform: "translate(-1020.155 -1022.742)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10790",
    "data-name": "Group 10790",
    transform: "translate(310.721 33.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    "data-name": "Path 3033",
    d: "M1523.844,1091.385l-39.364,3.957-18.447,1.85-19.347-60.324a9.546,9.546,0,0,1,2.8-10.083l2.807-2.457a9.763,9.763,0,0,1,2.288-1.482,8.968,8.968,0,0,1,2.113-.681c.063-.019.094-.025.094-.025.025-.006.044-.253.069-.259a9.6,9.6,0,0,1,1.713-.4h38.288a9.768,9.768,0,0,1,9.171,7.167Z",
    transform: "translate(-1446.233 -1021.479)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    "data-name": "Path 3034",
    d: "M1484.481,1096.606l-18.447,1.85-19.347-60.324a9.546,9.546,0,0,1,2.8-10.083l2.807-2.457a9.761,9.761,0,0,1,2.288-1.482c1.082-.369,1.857-.6,2.113-.681.063-.019.094-.025.094-.025.025-.006.044-.006.069-.013C1466.859,1021.861,1481.8,1084.922,1484.481,1096.606Z",
    transform: "translate(-1446.233 -1022.742)",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10792",
    "data-name": "Group 10792",
    transform: "translate(181.044 6.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    "data-name": "Path 3035",
    d: "M1283.374,1462.831l-2.155,7.554a2.581,2.581,0,0,0,1.168,2.97,6.739,6.739,0,0,0,2.167.7,3.006,3.006,0,0,0,3.237-1.69l2.748-5.946Z",
    transform: "translate(-1205.945 -1289.754)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    "data-name": "Path 3036",
    d: "M1189.015,1264.877s32.519,3.8,47.042,15.8-9.728,54.181-9.728,54.181-4.343.213-9.854-4.006c0,0,14.021-31.49-.014-39.672-15.778-9.2-33.447-10.49-33.447-10.49l5.744-14.815Z",
    transform: "translate(-1140.227 -1157.146)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3037",
    "data-name": "Path 3037",
    d: "M1100.893,1240.776s-6.1,19.523,1.378,24.945,24.9,11.028,29.354,22.4,8.791,28.093,17.889,35.589c0,0,9.018,2.549,11.16,0,0,0-6.381-31.375-10.109-39.82-3.229-7.313-7.974-17.865-16.258-23.452-2.371-1.6-2.126-4.354-1.217-7.066l1.655-4.939Z",
    transform: "translate(-1083.645 -1141.001)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3038",
    "data-name": "Path 3038",
    d: "M1275.176,1144.81c-11.954,1.386-9.276-17.983-9.1-18.757l-17.494,13.864s1.53,10.194,16.962,14.733a18.836,18.836,0,0,0,10.465.179A16.588,16.588,0,0,1,1275.176,1144.81Z",
    transform: "translate(-1184.15 -1064.149)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    "data-name": "Path 3039",
    d: "M1351.173,1159.19c-4.641-2.862-9.533.527-9.533.527-5.76,4.239-10.09,6.145-13.341,6.522a16.587,16.587,0,0,0,.832,10.019c6.615-1.809,11.137-6.919,13.081-9.52a2.165,2.165,0,0,1,2.974-.493c.971.683,1.931,1.64,1.825,2.708-.208,2.106,2.253,2.637,2.393,1.869s-1.119-5.2-1.119-5.2,5.117,4.607,7.112,6.375,4.272-.236,4.272-.236S1355.815,1162.053,1351.173,1159.19Z",
    transform: "translate(-1237.273 -1085.578)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    "data-name": "Path 3040",
    d: "M1119.314,1041.985s17.064-7.951,51.02,17.066c0,0,3.023,5.464.34,10.626s-29.533,31.069-32.662,44.787c0,0-16.5,6.386-34.583-5.6C1103.428,1108.867,1102.884,1071.2,1119.314,1041.985Z",
    transform: "translate(-1086.911 -1007.028)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    "data-name": "Path 3041",
    d: "M1237.375,1019.76l-8.015,10.888a3.424,3.424,0,0,0-.248,3.7c1.327,2.367,4.352,5.751,10.6,4.915a5.281,5.281,0,0,0,4.171-3.2l5.32-12.748Z",
    transform: "translate(-1170.821 -992.944)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    "data-name": "Path 3042",
    d: "M1074.755,1089.768c-2.481-8.138,17.021-27.664,17.021-27.664l-5.975-17.682s-42.677,31.943-30.075,55.038a17.3,17.3,0,0,0,6.668,7.029C1065.431,1096.689,1070.873,1091.97,1074.755,1089.768Z",
    transform: "translate(-1053.398 -1009.465)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    "data-name": "Path 3043",
    d: "M1116.379,1120.046a.486.486,0,0,1-.491-.343c-2.537-8.321,16.338-27.342,17.142-28.148a.486.486,0,1,1,.687.686c-.193.193-19.269,19.411-16.9,27.179a.485.485,0,0,1-.323.606A.5.5,0,0,1,1116.379,1120.046Z",
    transform: "translate(-1095.103 -1040.943)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3044",
    "data-name": "Path 3044",
    d: "M1124.049,1173.193s-23.806,10.789-30.136,4.013a3.991,3.991,0,0,1-.9-1.586c-3.882,2.2-9.324,6.921-12.361,16.721,13.246,7.469,34.413-6.464,40.119-10.541a4.423,4.423,0,0,1,3.235-.78c2.307.347,6.286.825,8.392.38,3.083-.651,8.154,10.068,13.005,6.408C1145.4,1187.807,1140.033,1168.984,1124.049,1173.193Z",
    transform: "translate(-1071.653 -1095.317)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10791",
    "data-name": "Group 10791",
    transform: "translate(60.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3045",
    "data-name": "Path 3045",
    d: "M1276.17,965.631c.1.33-.737,23.21-.737,23.21l-13.054-.759-2.424-21.8S1274.413,960.106,1276.17,965.631Z",
    transform: "translate(-1251.847 -955.143)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3046",
    "data-name": "Path 3046",
    d: "M1247.131,954.005l.377,11.578a1.59,1.59,0,0,0,.073.434c.274.867,1.437,3.78,4.345,2.409,2.639-1.244,5.066-2.34,6.908-2.095a1.617,1.617,0,0,1,1.4,1.663,69.923,69.923,0,0,1-1.184,10.792,1.613,1.613,0,0,1-1.777,1.262,52.142,52.142,0,0,1-11.844-2.7,1.619,1.619,0,0,1-1.016-1.307c-.354-2.88-1.463-11.629-2.149-14.019-.644-2.243-3.679-3.148-4.98-3.437a1.588,1.588,0,0,1-1.019-.732c-.8-1.321-2.122-4.467,1.783-6.495a1.621,1.621,0,0,0,.669-2.235c-.894-1.6-1.583-4.155,1.373-6.116,3-1.993,5.715-.665,7.257.523a1.619,1.619,0,0,0,2.075-.1,1.28,1.28,0,0,1,1.445-.189,1.594,1.594,0,0,0,2.115-1.044,4.832,4.832,0,0,1,5.08-3.679c5.8.03,7.474,6.171,6.594,10.079s-7.164,3.518-10.507,2.177c-2.542-1.02-5.292.948-6.465,1.95A1.605,1.605,0,0,0,1247.131,954.005Z",
    transform: "translate(-1235.394 -938.525)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3047",
    "data-name": "Path 3047",
    d: "M1244.029,1005.289s1.24-6.875-1.405-8.069-6.035.216-4.478,4.789C1240.083,1007.7,1244.029,1005.289,1244.029,1005.289Z",
    transform: "translate(-1236.974 -977.573)",
    fill: "url(#linear-gradient-31)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    "data-name": "Path 3048",
    d: "M1663.461,1137.186s4.888,24.88,6.655,24.88,34.526-3.92,34.526-3.92v-7.093l-25.91.952-6.259-18.49Z",
    transform: "translate(-1281.032 -1062.821)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    "data-name": "Path 3049",
    d: "M1556.261,1105.082H1512.62l2.651-31.031s-3.263-23.389,11.624-25.978c8.769-2.385,8.769-2.393,8.769-2.393s11.216-1.76,20.6,2.381,17.13,29.019,17.13,29.019l-11.216,4.485-2.855-9.144Z",
    transform: "translate(-1179.984 -1003.732)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    "data-name": "Path 3050",
    d: "M1580.439,1003.162l-7.979,15.72s8.114,6.358,16.643,4.25l1.1-16.69Z",
    transform: "translate(-1220.071 -975.498)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10793",
    "data-name": "Group 10793",
    transform: "translate(335.967 71.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    "data-name": "Path 3051",
    d: "M1527.809,1144.218a.2.2,0,0,1-.169-.089l-4.894-7.206a.2.2,0,0,1,.337-.229l4.895,7.206a.2.2,0,0,1-.169.319Z",
    transform: "translate(-1522.711 -1136.604)",
    fill: "url(#linear-gradient-35)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10794",
    "data-name": "Group 10794",
    transform: "translate(347.659 57.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    "data-name": "Path 3052",
    d: "M1562.256,1112.008a.2.2,0,0,1-.123-.367l1.8-1.354-5.794-16.036a.2.2,0,0,1,.384-.139l5.846,16.179a.2.2,0,0,1-.069.232l-1.924,1.444A.2.2,0,0,1,1562.256,1112.008Z",
    transform: "translate(-1558.13 -1093.977)",
    fill: "url(#linear-gradient-36)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10795",
    "data-name": "Group 10795",
    transform: "translate(280.152 98.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M1415.483,1221.169c0,1.431-.387,2.57-.864,2.57h-60.127c-.477,0-.864-1.139-.864-2.57h0c0-1.431.387-2.569.864-2.569h60.127c.477,0,.864,1.139.864,2.569Z",
    transform: "translate(-1353.629 -1218.6)",
    fill: "url(#linear-gradient-37)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    "data-name": "Path 3054",
    d: "M1740.165,1210.817H1685.7a1.706,1.706,0,0,0-1.789,1.946v1.651h58.581v-1.651A2.153,2.153,0,0,0,1740.165,1210.817Z",
    transform: "translate(-1294.733 -1114.605)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10801",
    "data-name": "Group 10801",
    transform: "translate(395.895 36.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10799",
    "data-name": "Group 10799"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    "data-name": "Path 3055",
    d: "M1769.354,1034.2l-6.984,47.842a3.412,3.412,0,0,1-3.283,2.83H1706.8a2.391,2.391,0,0,1-2.482-2.9l9.16-49.128a3.424,3.424,0,0,1,3.4-2.632l50.105,1.285A2.346,2.346,0,0,1,1769.354,1034.2Z",
    transform: "translate(-1704.267 -1030.209)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3056",
    "data-name": "Path 3056",
    d: "M1718.127,1031.109l-9.652,52.65a1.668,1.668,0,0,1-1.571,1.192,2.489,2.489,0,0,1-2.6-2.929l9.167-49.165a3.432,3.432,0,0,1,3.4-2.647l.879.022A.88.88,0,0,1,1718.127,1031.109Z",
    transform: "translate(-1704.254 -1030.209)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10798",
    "data-name": "Group 10798",
    transform: "translate(8.275 3.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10796",
    "data-name": "Group 10796",
    transform: "translate(45.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3057",
    "data-name": "Path 3057",
    d: "M1869.951,1072.476a.306.306,0,0,1-.287-.378l5-28.345a1.869,1.869,0,0,0-1.906-2.17l-5.311-.271a.3.3,0,0,1-.282-.369.41.41,0,0,1,.409-.333l5.308.272a2.458,2.458,0,0,1,2.469,2.9l-4.98,28.337A.427.427,0,0,1,1869.951,1072.476Z",
    transform: "translate(-1867.154 -1040.609)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10797",
    "data-name": "Group 10797",
    transform: "translate(0 32.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    "data-name": "Path 3058",
    d: "M1738.823,1153.763l-7.357-.015c-1.508,0-2.4-1.348-2.081-3.126l1.981-10.932a.461.461,0,0,1,.436-.373.306.306,0,0,1,.3.379l-1.975,10.927c-.243,1.341.392,2.356,1.476,2.358l7.352.017a.308.308,0,0,1,.3.382A.464.464,0,0,1,1738.823,1153.763Z",
    transform: "translate(-1729.32 -1139.318)",
    fill: "#91b3fa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10800",
    "data-name": "Group 10800",
    transform: "translate(18.474 24.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    "data-name": "Path 3059",
    d: "M1792.069,1212.422v.631l-12.653.317h-18.395a.845.845,0,0,1-.8-.851h0a3.093,3.093,0,0,1,2.945-3.26h25.967a3.47,3.47,0,0,1,.683.045A3.074,3.074,0,0,1,1792.069,1212.422Z",
    transform: "translate(-1760.218 -1174.317)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3060",
    "data-name": "Path 3060",
    d: "M1801.78,1212.4a3.114,3.114,0,0,0-3.138-3.105l-2.624.011-10.36.047-12.983.077a3.253,3.253,0,0,0-3.116,3.277.687.687,0,0,0,.62.689h30.981a.761.761,0,0,0,.62-.732Z",
    transform: "translate(-1766.475 -1174.337)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3061",
    "data-name": "Path 3061",
    d: "M1788.464,1103.406c-1.184,0-1.81,1.188-1.81,2.372v32.571h15.93v-34.943Z",
    transform: "translate(-1777.927 -1103.406)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3062",
    "data-name": "Path 3062",
    d: "M1807.323,1103.406H1795.19a2.5,2.5,0,0,0-2.309,2.372v32.571h16.443v-32.571A2.236,2.236,0,0,0,1807.323,1103.406Z",
    transform: "translate(-1782.099 -1103.406)",
    fill: "url(#linear-gradient-44)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3063",
    "data-name": "Path 3063",
    d: "M1657.1,1208.445h14.071s-3.195-6.865-9.041-6.526S1657.1,1208.445,1657.1,1208.445Z",
    transform: "translate(-1276.745 -1108.636)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3064",
    "data-name": "Path 3064",
    d: "M1540.976,1152.483l9.788-4.5,8.654,15.211s24.472-3.807,28.822.815,2.311,4.555,1.767,4.555-3.059-2.719-3.059-2.719,2.2,3.318,1.019,3.467-4.078-2.991-4.078-2.991,2.379,4.146.952,3.671-2.583-2.719-2.583-2.719,1.9,2.659.612,2.757-3.263-2.19-3.263-2.19a16.055,16.055,0,0,1-4.759,1.371c-1.733,0-19.2,4.362-22.364,2.549S1540.976,1152.483,1540.976,1152.483Z",
    transform: "translate(-1198.98 -1072.51)",
    fill: "url(#linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M1349.439,1210.817h-54.462a1.706,1.706,0,0,0-1.789,1.946v1.651h58.581v-1.651A2.153,2.153,0,0,0,1349.439,1210.817Z",
    transform: "translate(-1032.988 -1114.605)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10807",
    "data-name": "Group 10807",
    transform: "translate(266.915 36.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10805",
    "data-name": "Group 10805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M1378.628,1034.2l-6.983,47.842a3.412,3.412,0,0,1-3.283,2.83h-52.284a2.391,2.391,0,0,1-2.482-2.9l9.16-49.128a3.425,3.425,0,0,1,3.4-2.632l50.106,1.285A2.346,2.346,0,0,1,1378.628,1034.2Z",
    transform: "translate(-1313.541 -1030.209)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M1327.4,1031.109l-9.651,52.65a1.668,1.668,0,0,1-1.571,1.192,2.489,2.489,0,0,1-2.6-2.929l9.167-49.165a3.433,3.433,0,0,1,3.4-2.647l.88.022A.88.88,0,0,1,1327.4,1031.109Z",
    transform: "translate(-1313.529 -1030.209)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10804",
    "data-name": "Group 10804",
    transform: "translate(8.274 3.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10802",
    "data-name": "Group 10802",
    transform: "translate(45.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M1479.226,1072.476a.306.306,0,0,1-.287-.378l5-28.345a1.869,1.869,0,0,0-1.906-2.17l-5.31-.271a.3.3,0,0,1-.282-.369.41.41,0,0,1,.409-.333l5.308.272a2.458,2.458,0,0,1,2.469,2.9l-4.98,28.337A.427.427,0,0,1,1479.226,1072.476Z",
    transform: "translate(-1476.429 -1040.609)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10803",
    "data-name": "Group 10803",
    transform: "translate(0 32.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M1348.1,1153.763l-7.357-.015c-1.508,0-2.4-1.348-2.081-3.126l1.981-10.932a.461.461,0,0,1,.436-.373.305.305,0,0,1,.3.379l-1.975,10.927c-.242,1.341.392,2.356,1.476,2.358l7.353.017a.308.308,0,0,1,.3.382A.464.464,0,0,1,1348.1,1153.763Z",
    transform: "translate(-1338.595 -1139.318)",
    fill: "#91b3fa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10806",
    "data-name": "Group 10806",
    transform: "translate(18.474 24.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    "data-name": "Path 3070",
    d: "M1401.344,1212.422v.631l-12.653.317H1370.3a.845.845,0,0,1-.8-.851h0a3.093,3.093,0,0,1,2.945-3.26H1398.4a3.468,3.468,0,0,1,.683.045A3.074,3.074,0,0,1,1401.344,1212.422Z",
    transform: "translate(-1369.493 -1174.317)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    d: "M1411.055,1212.4a3.114,3.114,0,0,0-3.138-3.105l-2.624.011-10.359.047-12.983.077a3.253,3.253,0,0,0-3.116,3.277.687.687,0,0,0,.62.689h30.981a.761.761,0,0,0,.621-.732Z",
    transform: "translate(-1375.75 -1174.337)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    d: "M1397.739,1103.406c-1.184,0-1.81,1.188-1.81,2.372v32.571h15.93v-34.943Z",
    transform: "translate(-1387.202 -1103.406)",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    d: "M1416.6,1103.406h-12.133a2.5,2.5,0,0,0-2.309,2.372v32.571H1418.6v-32.571A2.236,2.236,0,0,0,1416.6,1103.406Z",
    transform: "translate(-1391.373 -1103.406)",
    fill: "url(#linear-gradient-53)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M1224.346,1208.445h14.071s-3.2-6.865-9.041-6.526S1224.346,1208.445,1224.346,1208.445Z",
    transform: "translate(-986.845 -1108.636)",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M815.073,1137.186s4.888,24.88,6.655,24.88,34.526-3.92,34.526-3.92v-7.093l-25.909.952-6.259-18.49Z",
    transform: "translate(-712.702 -1062.821)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M707.874,1105.082H664.233l2.651-31.031s-3.263-23.389,11.624-25.978c8.769-2.385,8.769-2.393,8.769-2.393s11.216-1.76,20.6,2.381S725,1077.079,725,1077.079l-11.216,4.485-2.855-9.144Z",
    transform: "translate(-611.655 -1003.732)",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M731.439,1001.069,727,1018.13s9.283,4.481,17.167.6l-2.488-16.54Z",
    transform: "translate(-653.699 -974.096)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M758.523,956.563s.709,12.368-1.042,18.077-1.885,9.783-8.768,8.524-11.144-6.49-12.04-13.151c0,0-1.458-10.291.876-13.425S758.523,956.563,758.523,956.563Z",
    transform: "translate(-659.88 -943.361)",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    d: "M724.853,946.574l.428-.027a.946.946,0,0,0,.884-1.06c-.262-2.1-.551-6.792,2.094-6.887,3.408-.122,16.015,1.811,20.08-1.417,3.906-3.1,3.656-9.058.959-11.72a.475.475,0,0,0-.654-.025l-.458.411a.468.468,0,0,1-.78-.382h0a.466.466,0,0,0-.75-.405c-1.237.958-4.08,2.2-10.077,1.167-8.522-1.47-14.988-.187-17.153,5.279a.469.469,0,0,1-.814.112c-.457-.576-1.338-1.093-2.988-.5-2.871,1.035-3.737,6.145-.383,11.848a.465.465,0,0,1-.28.7c-1.08.246-2.876,1.116-.175,4.155a12.074,12.074,0,0,0,6.509,4.153.466.466,0,0,0,.55-.4l.719-5.24a.469.469,0,0,1,.626-.376Z",
    transform: "translate(-644.373 -923.113)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M738.216,980.084s.741-7.461-3.015-6.677-1.229,8.212,1.13,9.372Z",
    transform: "translate(-657.912 -955.527)",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10814",
    "data-name": "Group 10814",
    transform: "translate(73.823 2.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10812",
    "data-name": "Group 10812",
    transform: "translate(4.57 21.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10808",
    "data-name": "Group 10808"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M753.637,1002.348c-7.989-.758-11.173-9.7-11.2-9.789l.578-.2c.03.086,3.09,8.66,10.684,9.38Z",
    transform: "translate(-742.432 -992.359)",
    fill: "url(#linear-gradient-61)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10811",
    "data-name": "Group 10811",
    transform: "translate(10.69 8.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10810",
    "data-name": "Group 10810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    "data-name": "SVGID",
    d: "M778.413,1020.117a.771.771,0,0,1-.771.771h-2.055a.771.771,0,0,1-.771-.771h0a.771.771,0,0,1,.771-.771h2.055a.771.771,0,0,1,.771.771Z",
    transform: "translate(-774.816 -1019.346)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10809",
    "data-name": "Group 10809",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M773.633,1022.183l-.01.753h.01Z",
    transform: "translate(-774.017 -1021.247)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3083",
    "data-name": "Path 3083",
    d: "M773.6,1019.346l.031,2.055h-.023l.394-1.119v-.937Z",
    transform: "translate(-774.001 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3084",
    "data-name": "Path 3084",
    d: "M773.622,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.001 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3085",
    "data-name": "Path 3085",
    d: "M773.691,1019.346l.031,2.055H773.7l-.031-2.055Z",
    transform: "translate(-774.047 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3086",
    "data-name": "Path 3086",
    d: "M773.76,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.093 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3087",
    "data-name": "Path 3087",
    d: "M773.829,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.14 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3088",
    "data-name": "Path 3088",
    d: "M773.9,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.186 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    "data-name": "Path 3089",
    d: "M773.967,1019.346,774,1021.4h-.023l-.031-2.055Z",
    transform: "translate(-774.232 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    d: "M774.037,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.279 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    d: "M774.106,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.325 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3092",
    "data-name": "Path 3092",
    d: "M774.175,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.371 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3093",
    "data-name": "Path 3093",
    d: "M774.244,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.418 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3094",
    "data-name": "Path 3094",
    d: "M774.313,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.464 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    "data-name": "Path 3095",
    d: "M774.382,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.51 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    "data-name": "Path 3096",
    d: "M774.451,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.556 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    d: "M774.521,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.603 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    d: "M774.59,1019.346l.031,2.055H774.6l-.031-2.055Z",
    transform: "translate(-774.649 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    "data-name": "Path 3099",
    d: "M774.659,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.695 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    d: "M774.728,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.742 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3101",
    "data-name": "Path 3101",
    d: "M774.8,1019.346l.031,2.055H774.8l-.031-2.055Z",
    transform: "translate(-774.788 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    d: "M774.866,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.834 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    d: "M774.935,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.881 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3104",
    "data-name": "Path 3104",
    d: "M775,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.927 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    d: "M775.074,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-774.973 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M775.143,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.02 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    d: "M775.212,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.066 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M775.281,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.112 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M775.35,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.159 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M775.419,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.205 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    "data-name": "Path 3111",
    d: "M775.488,1019.346l.031,2.055H775.5l-.031-2.055Z",
    transform: "translate(-775.251 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    "data-name": "Path 3112",
    d: "M775.558,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.297 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M775.627,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.344 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M775.7,1019.346l.031,2.055H775.7l-.031-2.055Z",
    transform: "translate(-775.39 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    "data-name": "Path 3115",
    d: "M775.765,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.436 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M775.834,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.483 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M775.9,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.529 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    "data-name": "Path 3118",
    d: "M775.972,1019.346,776,1021.4h-.023l-.031-2.055Z",
    transform: "translate(-775.575 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M776.042,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.622 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M776.111,1019.346l.03,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.668 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M776.18,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.714 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    "data-name": "Path 3122",
    d: "M776.249,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.761 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    "data-name": "Path 3123",
    d: "M776.318,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.807 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M776.387,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.853 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    "data-name": "Path 3125",
    d: "M776.456,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.9 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3126",
    "data-name": "Path 3126",
    d: "M776.525,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-775.946 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3127",
    "data-name": "Path 3127",
    d: "M776.595,1019.346l.031,2.055H776.6l-.031-2.055Z",
    transform: "translate(-775.992 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3128",
    "data-name": "Path 3128",
    d: "M776.664,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.039 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3129",
    "data-name": "Path 3129",
    d: "M776.733,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.085 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3130",
    "data-name": "Path 3130",
    d: "M776.8,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.131 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3131",
    "data-name": "Path 3131",
    d: "M776.871,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.177 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3132",
    "data-name": "Path 3132",
    d: "M776.94,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.224 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3133",
    "data-name": "Path 3133",
    d: "M777.009,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.27 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    "data-name": "Path 3134",
    d: "M777.078,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.316 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    "data-name": "Path 3135",
    d: "M777.148,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.363 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3136",
    "data-name": "Path 3136",
    d: "M777.217,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.409 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3137",
    "data-name": "Path 3137",
    d: "M777.286,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.455 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3138",
    "data-name": "Path 3138",
    d: "M777.355,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.502 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3139",
    "data-name": "Path 3139",
    d: "M777.424,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.548 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3140",
    "data-name": "Path 3140",
    d: "M777.493,1019.346l.031,2.055H777.5l-.031-2.055Z",
    transform: "translate(-776.594 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3141",
    "data-name": "Path 3141",
    d: "M777.562,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.641 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M777.632,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.687 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M777.7,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.733 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    "data-name": "Path 3144",
    d: "M777.77,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.779 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M777.839,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.826 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M777.908,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.872 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M777.977,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.918 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M778.046,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-776.965 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M778.116,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.011 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M778.185,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.057 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M778.254,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.104 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M778.323,1019.346l.03,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.15 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M778.392,1019.346l.031,2.055H778.4l-.03-2.055Z",
    transform: "translate(-777.196 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M778.461,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.243 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M778.53,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.289 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M778.6,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.335 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    "data-name": "Path 3157",
    d: "M778.668,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.381 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3158",
    "data-name": "Path 3158",
    d: "M778.738,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.428 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3159",
    "data-name": "Path 3159",
    d: "M778.807,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.474 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3160",
    "data-name": "Path 3160",
    d: "M778.876,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.521 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3161",
    "data-name": "Path 3161",
    d: "M778.945,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.567 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3162",
    "data-name": "Path 3162",
    d: "M779.014,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.613 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3163",
    "data-name": "Path 3163",
    d: "M779.083,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.659 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3164",
    "data-name": "Path 3164",
    d: "M779.152,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.706 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3165",
    "data-name": "Path 3165",
    d: "M779.222,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.752 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3166",
    "data-name": "Path 3166",
    d: "M779.291,1019.346l.031,2.055H779.3l-.03-2.055Z",
    transform: "translate(-777.798 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    "data-name": "Path 3167",
    d: "M779.36,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.845 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M779.429,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.891 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3169",
    "data-name": "Path 3169",
    d: "M779.5,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.937 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    "data-name": "Path 3170",
    d: "M779.567,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-777.984 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    d: "M779.636,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.03 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3172",
    "data-name": "Path 3172",
    d: "M779.706,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.076 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    d: "M779.775,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.122 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    "data-name": "Path 3174",
    d: "M779.844,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.169 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    "data-name": "Path 3175",
    d: "M779.913,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.215 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    "data-name": "Path 3176",
    d: "M779.982,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.262 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    "data-name": "Path 3177",
    d: "M780.051,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.308 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    d: "M780.12,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.354 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3179",
    "data-name": "Path 3179",
    d: "M780.189,1019.346l.031,2.055H780.2l-.031-2.055Z",
    transform: "translate(-778.4 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3180",
    "data-name": "Path 3180",
    d: "M780.259,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.447 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    "data-name": "Path 3181",
    d: "M780.328,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.493 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    "data-name": "Path 3182",
    d: "M780.4,1019.346l.031,2.055H780.4l-.031-2.055Z",
    transform: "translate(-778.539 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    "data-name": "Path 3183",
    d: "M780.466,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.586 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    "data-name": "Path 3184",
    d: "M780.535,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.632 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3185",
    "data-name": "Path 3185",
    d: "M780.6,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.678 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    "data-name": "Path 3186",
    d: "M780.673,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.725 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    "data-name": "Path 3187",
    d: "M780.743,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.771 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    d: "M780.812,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.817 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    d: "M780.881,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.863 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    "data-name": "Path 3190",
    d: "M780.95,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.91 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    "data-name": "Path 3191",
    d: "M781.019,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-778.956 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    "data-name": "Path 3192",
    d: "M781.088,1019.346l.031,2.055H781.1l-.031-2.055Z",
    transform: "translate(-779.002 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3193",
    "data-name": "Path 3193",
    d: "M781.157,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.049 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3194",
    "data-name": "Path 3194",
    d: "M781.226,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.095 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    "data-name": "Path 3195",
    d: "M781.3,1019.346l.031,2.055H781.3l-.031-2.055Z",
    transform: "translate(-779.141 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    "data-name": "Path 3196",
    d: "M781.365,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.188 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    "data-name": "Path 3197",
    d: "M781.434,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.234 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    "data-name": "Path 3198",
    d: "M781.5,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.28 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3199",
    "data-name": "Path 3199",
    d: "M781.572,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.327 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3200",
    "data-name": "Path 3200",
    d: "M781.641,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.373 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3201",
    "data-name": "Path 3201",
    d: "M781.71,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.419 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3202",
    "data-name": "Path 3202",
    d: "M781.779,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.465 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3203",
    "data-name": "Path 3203",
    d: "M781.849,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.512 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3204",
    "data-name": "Path 3204",
    d: "M781.918,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.558 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3205",
    "data-name": "Path 3205",
    d: "M781.987,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.604 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3206",
    "data-name": "Path 3206",
    d: "M782.056,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.651 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3207",
    "data-name": "Path 3207",
    d: "M782.125,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.697 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3208",
    "data-name": "Path 3208",
    d: "M782.194,1019.346l.031,2.055H782.2l-.031-2.055Z",
    transform: "translate(-779.743 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3209",
    "data-name": "Path 3209",
    d: "M782.263,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.79 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3210",
    "data-name": "Path 3210",
    d: "M782.333,1019.346l.03,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.836 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3211",
    "data-name": "Path 3211",
    d: "M782.4,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.882 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3212",
    "data-name": "Path 3212",
    d: "M782.471,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.929 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3213",
    "data-name": "Path 3213",
    d: "M782.54,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-779.975 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3214",
    "data-name": "Path 3214",
    d: "M782.609,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.021 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    d: "M782.678,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.068 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3216",
    "data-name": "Path 3216",
    d: "M782.747,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.114 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3217",
    "data-name": "Path 3217",
    d: "M782.817,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.16 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3218",
    "data-name": "Path 3218",
    d: "M782.885,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.206 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3219",
    "data-name": "Path 3219",
    d: "M782.955,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.253 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3220",
    "data-name": "Path 3220",
    d: "M783.024,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.299 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    d: "M783.093,1019.346l.031,2.055H783.1l-.031-2.055Z",
    transform: "translate(-780.346 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    "data-name": "Path 3222",
    d: "M783.162,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.392 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3223",
    "data-name": "Path 3223",
    d: "M783.231,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.438 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3224",
    "data-name": "Path 3224",
    d: "M783.3,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.484 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3225",
    "data-name": "Path 3225",
    d: "M783.369,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.531 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3226",
    "data-name": "Path 3226",
    d: "M783.439,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.577 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3227",
    "data-name": "Path 3227",
    d: "M783.508,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.623 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3228",
    "data-name": "Path 3228",
    d: "M783.577,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.67 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3229",
    "data-name": "Path 3229",
    d: "M783.646,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.716 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3230",
    "data-name": "Path 3230",
    d: "M783.715,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.762 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3231",
    "data-name": "Path 3231",
    d: "M783.784,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.809 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3232",
    "data-name": "Path 3232",
    d: "M783.853,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.855 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3233",
    "data-name": "Path 3233",
    d: "M783.923,1019.346l.031,2.055h-.023l-.031-2.055Z",
    transform: "translate(-780.901 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3234",
    "data-name": "Path 3234",
    d: "M783.992,1019.346l.039.82v1.235H784l-.031-2.055Z",
    transform: "translate(-780.947 -1019.346)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3235",
    "data-name": "Path 3235",
    d: "M784.043,1020.22l0-.793h0Z",
    transform: "translate(-780.994 -1019.4)",
    fill: "url(#linear-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10813",
    "data-name": "Group 10813"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3236",
    "data-name": "Path 3236",
    d: "M744.3,939.819s5.011-12.109,13.085-12.056a5.78,5.78,0,0,0-4.558-.628c-2.527.748-9.528,5.925-10.548,12.683C743.774,940.6,744.3,939.819,744.3,939.819Z",
    transform: "translate(-737.76 -926.913)",
    fill: "url(#linear-gradient-217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3237",
    "data-name": "Path 3237",
    d: "M733.924,963.005c-4.486.136-4.894,5.71-4.894,5.71-.995,3.925-.172,6.1,1.155,7.292a3.475,3.475,0,0,0,5.7-1.746c.266-1.069.534-2.083.677-2.434C736.9,970.975,738.41,962.87,733.924,963.005Z",
    transform: "translate(-728.589 -951.09)",
    fill: "url(#linear-gradient-218)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3238",
    "data-name": "Path 3238",
    d: "M736.692,967.179a2,2,0,0,0-2.349.792c-3.621,5.558-1.11,10.008.438,10.358,1.631.368,2.957-7.557,2.956-9.647A1.469,1.469,0,0,0,736.692,967.179Z",
    transform: "translate(-731.197 -953.809)",
    fill: "url(#linear-gradient-219)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10815",
    "data-name": "Group 10815",
    transform: "translate(55.909 71.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3239",
    "data-name": "Path 3239",
    d: "M679.422,1144.218a.2.2,0,0,1-.169-.089l-4.894-7.206a.2.2,0,0,1,.337-.229l4.894,7.206a.2.2,0,0,1-.168.319Z",
    transform: "translate(-674.323 -1136.604)",
    fill: "url(#linear-gradient-220)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10816",
    "data-name": "Group 10816",
    transform: "translate(67.601 57.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3240",
    "data-name": "Path 3240",
    d: "M713.868,1112.008a.2.2,0,0,1-.122-.367l1.8-1.354-5.795-16.036a.2.2,0,0,1,.384-.139l5.846,16.179a.2.2,0,0,1-.069.232l-1.925,1.444A.2.2,0,0,1,713.868,1112.008Z",
    transform: "translate(-709.742 -1093.977)",
    fill: "url(#linear-gradient-221)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3241",
    "data-name": "Path 3241",
    d: "M864.922,1234.167H515.789c5.231,28.777,10.464,56.528,15.695,84.808a3.835,3.835,0,0,0,3.364,3.063H973.933a3.712,3.712,0,0,0,3.247-3.063c5.23-28.28,10.464-56.032,15.695-84.808Z",
    transform: "translate(-512.213 -1130.247)",
    fill: "url(#linear-gradient-222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3242",
    "data-name": "Path 3242",
    d: "M585.691,1234.167c-2.09,28.777-4.176,58.581-6.265,87.871H534.848a3.835,3.835,0,0,1-3.364-3.063c-5.23-28.28-10.464-56.032-15.695-84.808Z",
    transform: "translate(-512.213 -1130.247)",
    fill: "url(#linear-gradient-223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3243",
    "data-name": "Path 3243",
    d: "M990.573,1213.386H677.452v-.623a2.153,2.153,0,0,0-2.33-1.946H620.66a1.706,1.706,0,0,0-1.789,1.946v.623H514.918a2.58,2.58,0,1,0,0,5.139H990.573a2.58,2.58,0,1,0,0-5.139Z",
    transform: "translate(-509.748 -1114.605)",
    fill: "url(#linear-gradient-224)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10822",
    "data-name": "Group 10822",
    transform: "translate(115.838 36.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10820",
    "data-name": "Group 10820"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3244",
    "data-name": "Path 3244",
    d: "M920.966,1034.2l-6.983,47.842a3.412,3.412,0,0,1-3.283,2.83H858.416a2.391,2.391,0,0,1-2.482-2.9l9.16-49.128a3.425,3.425,0,0,1,3.4-2.632L918.6,1031.5A2.346,2.346,0,0,1,920.966,1034.2Z",
    transform: "translate(-855.879 -1030.209)",
    fill: "url(#linear-gradient-225)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3245",
    "data-name": "Path 3245",
    d: "M869.74,1031.109l-9.652,52.65a1.668,1.668,0,0,1-1.571,1.192,2.489,2.489,0,0,1-2.6-2.929l9.167-49.165a3.433,3.433,0,0,1,3.4-2.647l.879.022A.88.88,0,0,1,869.74,1031.109Z",
    transform: "translate(-855.867 -1030.209)",
    fill: "url(#linear-gradient-226)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10819",
    "data-name": "Group 10819",
    transform: "translate(8.274 3.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10817",
    "data-name": "Group 10817",
    transform: "translate(45.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3246",
    "data-name": "Path 3246",
    d: "M1021.563,1072.476a.306.306,0,0,1-.287-.378l5-28.345a1.869,1.869,0,0,0-1.906-2.17l-5.31-.271a.3.3,0,0,1-.282-.369.41.41,0,0,1,.41-.333l5.307.272a2.458,2.458,0,0,1,2.469,2.9l-4.979,28.337A.428.428,0,0,1,1021.563,1072.476Z",
    transform: "translate(-1018.766 -1040.609)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10818",
    "data-name": "Group 10818",
    transform: "translate(0 32.584)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3247",
    "data-name": "Path 3247",
    d: "M890.436,1153.763l-7.357-.015c-1.508,0-2.4-1.348-2.081-3.126l1.981-10.932a.461.461,0,0,1,.436-.373.305.305,0,0,1,.3.379l-1.975,10.927c-.242,1.341.393,2.356,1.476,2.358l7.352.017a.308.308,0,0,1,.3.382A.464.464,0,0,1,890.436,1153.763Z",
    transform: "translate(-880.933 -1139.318)",
    fill: "#91b3fa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10821",
    "data-name": "Group 10821",
    transform: "translate(18.474 24.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3248",
    "data-name": "Path 3248",
    d: "M943.682,1212.422v.631l-12.653.317H912.633a.845.845,0,0,1-.8-.851h0a3.093,3.093,0,0,1,2.945-3.26h25.966a3.468,3.468,0,0,1,.683.045A3.074,3.074,0,0,1,943.682,1212.422Z",
    transform: "translate(-911.831 -1174.317)",
    fill: "url(#linear-gradient-227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3249",
    "data-name": "Path 3249",
    d: "M953.392,1212.4a3.114,3.114,0,0,0-3.138-3.105l-2.624.011-10.36.047-12.983.077a3.253,3.253,0,0,0-3.117,3.277.687.687,0,0,0,.621.689h30.981a.761.761,0,0,0,.621-.732Z",
    transform: "translate(-918.088 -1174.337)",
    fill: "url(#linear-gradient-228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3250",
    "data-name": "Path 3250",
    d: "M940.076,1103.406c-1.184,0-1.81,1.188-1.81,2.372v32.571H954.2v-34.943Z",
    transform: "translate(-929.54 -1103.406)",
    fill: "url(#linear-gradient-229)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3251",
    "data-name": "Path 3251",
    d: "M958.935,1103.406H946.8a2.5,2.5,0,0,0-2.309,2.372v32.571h16.444v-32.571A2.236,2.236,0,0,0,958.935,1103.406Z",
    transform: "translate(-933.711 -1103.406)",
    fill: "url(#linear-gradient-230)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3252",
    "data-name": "Path 3252",
    d: "M808.714,1208.445h14.071s-3.2-6.865-9.041-6.526S808.714,1208.445,808.714,1208.445Z",
    transform: "translate(-708.416 -1108.636)",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3253",
    "data-name": "Path 3253",
    d: "M692.588,1152.483l9.788-4.5,8.654,15.211s24.472-3.807,28.823.815,2.311,4.555,1.767,4.555-3.059-2.719-3.059-2.719,2.205,3.318,1.02,3.467-4.079-2.991-4.079-2.991,2.379,4.146.952,3.671-2.583-2.719-2.583-2.719,1.9,2.659.612,2.757-3.263-2.19-3.263-2.19a16.051,16.051,0,0,1-4.758,1.371c-1.733,0-19.2,4.362-22.364,2.549S692.588,1152.483,692.588,1152.483Z",
    transform: "translate(-630.65 -1072.51)",
    fill: "url(#linear-gradient-232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3254",
    "data-name": "Path 3254",
    d: "M569.594,1221.169a2.712,2.712,0,0,1,2.835-2.569H507.791a2.582,2.582,0,1,0,0,5.139h64.638A2.712,2.712,0,0,1,569.594,1221.169Z",
    transform: "translate(-504.956 -1119.819)",
    fill: "url(#linear-gradient-233)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10826",
    "data-name": "Group 10826",
    transform: "translate(241.416 10.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10824",
    "data-name": "Group 10824",
    transform: "translate(4.734 21.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10823",
    "data-name": "Group 10823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3255",
    "data-name": "Path 3255",
    d: "M1262.937,1025.923c-8.021.218-12.268-8.271-12.31-8.357l.55-.269c.04.082,4.119,8.221,11.744,8.014Z",
    transform: "translate(-1250.627 -1017.297)",
    fill: "url(#linear-gradient-234)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1657",
    "data-name": "Rectangle 1657",
    width: 3.798,
    height: 1.821,
    rx: 0.91,
    transform: "translate(11.479 7.457) rotate(-7.633)",
    fill: "url(#linear-gradient-235)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10825",
    "data-name": "Group 10825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    "data-name": "Path 3256",
    d: "M1247.652,965.185s3.5-12.628,11.525-13.555a5.779,5.779,0,0,0-4.6-.069c-2.417,1.049-8.739,7.037-8.93,13.87C1247.225,966.02,1247.652,965.185,1247.652,965.185Z",
    transform: "translate(-1242.556 -951.112)",
    fill: "url(#linear-gradient-236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3257",
    "data-name": "Path 3257",
    d: "M1240.578,988.015c-4.437.679-4.165,6.262-4.165,6.262-.512,4.017.569,6.073,2.031,7.1a3.476,3.476,0,0,0,5.443-2.425c.134-1.093.277-2.132.377-2.5C1244.5,995.564,1245.015,987.335,1240.578,988.015Z",
    transform: "translate(-1236.285 -975.806)",
    fill: "url(#linear-gradient-237)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3258",
    "data-name": "Path 3258",
    d: "M1243.3,992.312a2,2,0,0,0-2.235,1.071c-2.92,5.956.113,10.069,1.692,10.228,1.664.168,2.018-7.86,1.763-9.935A1.468,1.468,0,0,0,1243.3,992.312Z",
    transform: "translate(-1238.666 -978.679)",
    fill: "url(#linear-gradient-238)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10835",
    "data-name": "Group 10835",
    transform: "translate(349.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10827",
    "data-name": "Group 10827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3259",
    "data-name": "Path 3259",
    d: "M1612.821,962.456s-1.934,13.6-7.157,17.78-15.4,1.033-18.838-9.218l6.849-17.528Z",
    transform: "translate(-1579.145 -942.223)",
    fill: "url(#linear-gradient-239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3260",
    "data-name": "Path 3260",
    d: "M1577.317,941.968a.673.673,0,0,0,.875-.539A17.579,17.579,0,0,1,1579.8,936s-.5-1.784,4.509.911,12.528,6.654,16.956,4.3c4.317-2.3,8.69-13.866-2.719-11.723a.673.673,0,0,1-.8-.7c.14-1.9-.048-6.275-4.478-7.679-4.145-1.314-1.92.816-2.854,1.945-.275.332.347-1.131-5.542-.275-2.021.294-4.614-5.071-9.577-2.884-4.089,1.8-4.724,4.32-4.657,5.889a.671.671,0,0,1-.956.64c-1.252-.577-3.266-.876-5.2,1.541-2.667,3.342,1.144,6.24,2.288,7a.675.675,0,0,1,.305.556c.011,1.738.282,9.319,4.081,13.6a.679.679,0,0,0,1.129-.2l2.925-6.97a.676.676,0,0,1,.831-.382Z",
    transform: "translate(-1563.559 -919.359)",
    fill: "url(#linear-gradient-240)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3261",
    "data-name": "Path 3261",
    d: "M1594.289,981.207s-1.787-7.276-4.5-4.914.707,7.562,3.816,8.553Z",
    transform: "translate(-1580.469 -957.183)",
    fill: "url(#linear-gradient-241)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10834",
    "data-name": "Group 10834",
    transform: "translate(6.164 2.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10832",
    "data-name": "Group 10832",
    transform: "translate(4.51 20.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10828",
    "data-name": "Group 10828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3262",
    "data-name": "Path 3262",
    d: "M1606.418,1000.5c-7.92-1.29-10.5-10.424-10.525-10.516l.59-.161c.024.088,2.5,8.848,10.033,10.074Z",
    transform: "translate(-1595.893 -989.819)",
    fill: "url(#linear-gradient-242)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10831",
    "data-name": "Group 10831",
    transform: "translate(9.86 9.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10830",
    "data-name": "Group 10830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10829",
    "data-name": "Group 10829",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3263",
    "data-name": "Path 3263",
    d: "M1624.968,1021.547l-.061.751h.01Z",
    transform: "translate(-1625.19 -1020.49)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3264",
    "data-name": "Path 3264",
    d: "M1625,1018.148l-.107,2.053-.023,0,.272-.916.075-1.121Z",
    transform: "translate(-1625.166 -1018.213)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3265",
    "data-name": "Path 3265",
    d: "M1625.07,1018.15l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.212 -1018.213)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3266",
    "data-name": "Path 3266",
    d: "M1625.139,1018.155l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.258 -1018.216)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3267",
    "data-name": "Path 3267",
    d: "M1625.208,1018.159l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.304 -1018.219)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3268",
    "data-name": "Path 3268",
    d: "M1625.277,1018.164l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1625.351 -1018.222)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3269",
    "data-name": "Path 3269",
    d: "M1625.346,1018.168l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.397 -1018.225)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3270",
    "data-name": "Path 3270",
    d: "M1625.415,1018.173l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.443 -1018.228)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3271",
    "data-name": "Path 3271",
    d: "M1625.484,1018.178l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1625.489 -1018.231)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3272",
    "data-name": "Path 3272",
    d: "M1625.553,1018.182l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.535 -1018.234)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3273",
    "data-name": "Path 3273",
    d: "M1625.622,1018.187l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1625.582 -1018.238)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3274",
    "data-name": "Path 3274",
    d: "M1625.691,1018.191l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1625.628 -1018.241)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3275",
    "data-name": "Path 3275",
    d: "M1625.76,1018.2l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.674 -1018.244)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3276",
    "data-name": "Path 3276",
    d: "M1625.829,1018.2l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.72 -1018.247)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3277",
    "data-name": "Path 3277",
    d: "M1625.9,1018.205l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1625.767 -1018.25)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3278",
    "data-name": "Path 3278",
    d: "M1625.967,1018.21l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.813 -1018.253)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3279",
    "data-name": "Path 3279",
    d: "M1626.036,1018.215l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.859 -1018.256)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3280",
    "data-name": "Path 3280",
    d: "M1626.1,1018.219l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.905 -1018.259)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3281",
    "data-name": "Path 3281",
    d: "M1626.174,1018.224l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1625.951 -1018.262)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3282",
    "data-name": "Path 3282",
    d: "M1626.243,1018.229l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1625.997 -1018.266)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3283",
    "data-name": "Path 3283",
    d: "M1626.312,1018.233l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.044 -1018.269)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3284",
    "data-name": "Path 3284",
    d: "M1626.381,1018.238l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.09 -1018.272)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3285",
    "data-name": "Path 3285",
    d: "M1626.45,1018.242l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1626.136 -1018.275)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3286",
    "data-name": "Path 3286",
    d: "M1626.519,1018.247l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.182 -1018.278)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3287",
    "data-name": "Path 3287",
    d: "M1626.588,1018.252l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.229 -1018.281)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3288",
    "data-name": "Path 3288",
    d: "M1626.657,1018.256l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1626.275 -1018.284)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3289",
    "data-name": "Path 3289",
    d: "M1626.726,1018.261l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.321 -1018.287)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3290",
    "data-name": "Path 3290",
    d: "M1626.795,1018.266l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.367 -1018.29)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3291",
    "data-name": "Path 3291",
    d: "M1626.864,1018.27l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.414 -1018.293)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3292",
    "data-name": "Path 3292",
    d: "M1626.933,1018.275l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.459 -1018.296)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3293",
    "data-name": "Path 3293",
    d: "M1627,1018.279l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.506 -1018.299)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3294",
    "data-name": "Path 3294",
    d: "M1627.07,1018.284l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1626.552 -1018.303)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3295",
    "data-name": "Path 3295",
    d: "M1627.139,1018.289l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.598 -1018.306)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3296",
    "data-name": "Path 3296",
    d: "M1627.208,1018.293l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.644 -1018.309)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3297",
    "data-name": "Path 3297",
    d: "M1627.277,1018.3l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1626.691 -1018.312)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3298",
    "data-name": "Path 3298",
    d: "M1627.346,1018.3l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.737 -1018.315)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3299",
    "data-name": "Path 3299",
    d: "M1627.416,1018.307l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1626.783 -1018.318)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3300",
    "data-name": "Path 3300",
    d: "M1627.484,1018.312l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.829 -1018.321)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3301",
    "data-name": "Path 3301",
    d: "M1627.553,1018.316l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1626.875 -1018.324)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3302",
    "data-name": "Path 3302",
    d: "M1627.622,1018.321l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1626.922 -1018.328)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3303",
    "data-name": "Path 3303",
    d: "M1627.691,1018.326l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1626.968 -1018.331)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3304",
    "data-name": "Path 3304",
    d: "M1627.76,1018.33l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.014 -1018.334)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3305",
    "data-name": "Path 3305",
    d: "M1627.829,1018.335l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.06 -1018.337)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3306",
    "data-name": "Path 3306",
    d: "M1627.9,1018.339l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1627.106 -1018.34)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3307",
    "data-name": "Path 3307",
    d: "M1627.967,1018.344l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.153 -1018.343)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3308",
    "data-name": "Path 3308",
    d: "M1628.036,1018.349l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.199 -1018.346)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3309",
    "data-name": "Path 3309",
    d: "M1628.105,1018.353l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.245 -1018.349)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3310",
    "data-name": "Path 3310",
    d: "M1628.174,1018.358l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1627.291 -1018.352)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3311",
    "data-name": "Path 3311",
    d: "M1628.243,1018.362l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.338 -1018.355)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3312",
    "data-name": "Path 3312",
    d: "M1628.312,1018.367l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.384 -1018.358)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3313",
    "data-name": "Path 3313",
    d: "M1628.381,1018.372l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1627.43 -1018.361)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3314",
    "data-name": "Path 3314",
    d: "M1628.45,1018.376l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.476 -1018.365)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3315",
    "data-name": "Path 3315",
    d: "M1628.519,1018.381l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.522 -1018.368)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3316",
    "data-name": "Path 3316",
    d: "M1628.588,1018.385l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.568 -1018.371)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3317",
    "data-name": "Path 3317",
    d: "M1628.657,1018.39l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.615 -1018.374)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3318",
    "data-name": "Path 3318",
    d: "M1628.726,1018.395l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.661 -1018.377)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3319",
    "data-name": "Path 3319",
    d: "M1628.795,1018.4l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1627.707 -1018.38)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3320",
    "data-name": "Path 3320",
    d: "M1628.864,1018.4l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.753 -1018.383)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3321",
    "data-name": "Path 3321",
    d: "M1628.933,1018.409l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.799 -1018.386)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3322",
    "data-name": "Path 3322",
    d: "M1629,1018.413l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.846 -1018.389)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3323",
    "data-name": "Path 3323",
    d: "M1629.071,1018.418l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1627.892 -1018.392)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3324",
    "data-name": "Path 3324",
    d: "M1629.14,1018.423l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1627.938 -1018.396)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3325",
    "data-name": "Path 3325",
    d: "M1629.209,1018.427l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1627.984 -1018.399)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3326",
    "data-name": "Path 3326",
    d: "M1629.278,1018.432l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1628.031 -1018.402)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3327",
    "data-name": "Path 3327",
    d: "M1629.347,1018.437l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.077 -1018.405)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3328",
    "data-name": "Path 3328",
    d: "M1629.416,1018.441l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.123 -1018.408)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3329",
    "data-name": "Path 3329",
    d: "M1629.485,1018.446l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.169 -1018.411)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3330",
    "data-name": "Path 3330",
    d: "M1629.554,1018.45l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1628.215 -1018.414)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3331",
    "data-name": "Path 3331",
    d: "M1629.623,1018.455l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.262 -1018.417)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3332",
    "data-name": "Path 3332",
    d: "M1629.692,1018.46l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.308 -1018.42)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3333",
    "data-name": "Path 3333",
    d: "M1629.761,1018.464l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.354 -1018.423)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3334",
    "data-name": "Path 3334",
    d: "M1629.83,1018.469l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.4 -1018.427)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3335",
    "data-name": "Path 3335",
    d: "M1629.9,1018.473l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.446 -1018.43)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3336",
    "data-name": "Path 3336",
    d: "M1629.968,1018.478l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.493 -1018.433)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3337",
    "data-name": "Path 3337",
    d: "M1630.036,1018.483l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.539 -1018.436)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3338",
    "data-name": "Path 3338",
    d: "M1630.105,1018.487l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1628.585 -1018.439)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3339",
    "data-name": "Path 3339",
    d: "M1630.175,1018.492l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.632 -1018.442)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3340",
    "data-name": "Path 3340",
    d: "M1630.244,1018.5l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1628.678 -1018.445)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3341",
    "data-name": "Path 3341",
    d: "M1630.313,1018.5l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.724 -1018.448)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3342",
    "data-name": "Path 3342",
    d: "M1630.382,1018.506l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1628.77 -1018.451)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3343",
    "data-name": "Path 3343",
    d: "M1630.45,1018.51l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.816 -1018.454)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3344",
    "data-name": "Path 3344",
    d: "M1630.519,1018.515l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1628.862 -1018.458)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3345",
    "data-name": "Path 3345",
    d: "M1630.588,1018.52l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.909 -1018.461)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    d: "M1630.657,1018.524l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1628.955 -1018.464)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3347",
    "data-name": "Path 3347",
    d: "M1630.726,1018.529l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1629.001 -1018.467)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3348",
    "data-name": "Path 3348",
    d: "M1630.8,1018.534l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1629.047 -1018.47)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3349",
    "data-name": "Path 3349",
    d: "M1630.864,1018.538l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.093 -1018.473)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3350",
    "data-name": "Path 3350",
    d: "M1630.933,1018.543l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.14 -1018.476)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3351",
    "data-name": "Path 3351",
    d: "M1631,1018.547l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.186 -1018.479)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3352",
    "data-name": "Path 3352",
    d: "M1631.071,1018.552l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1629.232 -1018.482)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3353",
    "data-name": "Path 3353",
    d: "M1631.14,1018.557l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.278 -1018.485)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3354",
    "data-name": "Path 3354",
    d: "M1631.209,1018.561l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.324 -1018.488)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3355",
    "data-name": "Path 3355",
    d: "M1631.278,1018.566l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1629.37 -1018.491)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3356",
    "data-name": "Path 3356",
    d: "M1631.347,1018.57l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.417 -1018.495)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3357",
    "data-name": "Path 3357",
    d: "M1631.416,1018.575l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.463 -1018.498)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3358",
    "data-name": "Path 3358",
    d: "M1631.485,1018.58l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1629.509 -1018.501)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3359",
    "data-name": "Path 3359",
    d: "M1631.554,1018.584l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.555 -1018.504)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3360",
    "data-name": "Path 3360",
    d: "M1631.623,1018.589l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.602 -1018.507)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3361",
    "data-name": "Path 3361",
    d: "M1631.692,1018.594l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.648 -1018.51)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3362",
    "data-name": "Path 3362",
    d: "M1631.761,1018.6l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1629.694 -1018.513)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3363",
    "data-name": "Path 3363",
    d: "M1631.83,1018.6l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.74 -1018.516)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3364",
    "data-name": "Path 3364",
    d: "M1631.9,1018.608l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.786 -1018.519)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3365",
    "data-name": "Path 3365",
    d: "M1631.968,1018.612l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1629.833 -1018.522)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3366",
    "data-name": "Path 3366",
    d: "M1632.037,1018.617l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.879 -1018.526)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3367",
    "data-name": "Path 3367",
    d: "M1632.106,1018.622l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.925 -1018.529)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3368",
    "data-name": "Path 3368",
    d: "M1632.175,1018.626l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1629.971 -1018.532)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3369",
    "data-name": "Path 3369",
    d: "M1632.244,1018.631l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1630.017 -1018.535)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3370",
    "data-name": "Path 3370",
    d: "M1632.313,1018.635l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1630.064 -1018.538)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3371",
    "data-name": "Path 3371",
    d: "M1632.382,1018.64l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1630.11 -1018.541)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3372",
    "data-name": "Path 3372",
    d: "M1632.451,1018.644l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.156 -1018.544)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3373",
    "data-name": "Path 3373",
    d: "M1632.52,1018.649l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.203 -1018.547)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3374",
    "data-name": "Path 3374",
    d: "M1632.589,1018.654l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.248 -1018.55)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3375",
    "data-name": "Path 3375",
    d: "M1632.658,1018.658l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.295 -1018.553)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3376",
    "data-name": "Path 3376",
    d: "M1632.727,1018.663l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.341 -1018.557)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3377",
    "data-name": "Path 3377",
    d: "M1632.8,1018.667l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1630.387 -1018.56)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3378",
    "data-name": "Path 3378",
    d: "M1632.865,1018.672l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.433 -1018.563)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3379",
    "data-name": "Path 3379",
    d: "M1632.934,1018.677l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.479 -1018.566)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3380",
    "data-name": "Path 3380",
    d: "M1633,1018.682l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1630.526 -1018.569)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3381",
    "data-name": "Path 3381",
    d: "M1633.072,1018.686l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.572 -1018.572)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3382",
    "data-name": "Path 3382",
    d: "M1633.141,1018.691l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.618 -1018.575)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3383",
    "data-name": "Path 3383",
    d: "M1633.209,1018.7l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1630.664 -1018.578)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3384",
    "data-name": "Path 3384",
    d: "M1633.278,1018.7l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1630.711 -1018.581)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3385",
    "data-name": "Path 3385",
    d: "M1633.348,1018.7l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.757 -1018.584)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3386",
    "data-name": "Path 3386",
    d: "M1633.417,1018.709l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.803 -1018.588)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3387",
    "data-name": "Path 3387",
    d: "M1633.485,1018.714l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1630.849 -1018.591)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3388",
    "data-name": "Path 3388",
    d: "M1633.555,1018.718l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1630.896 -1018.594)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3389",
    "data-name": "Path 3389",
    d: "M1633.624,1018.723l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1630.942 -1018.597)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3390",
    "data-name": "Path 3390",
    d: "M1633.692,1018.728l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1630.988 -1018.6)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3391",
    "data-name": "Path 3391",
    d: "M1633.761,1018.732l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.034 -1018.603)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3392",
    "data-name": "Path 3392",
    d: "M1633.83,1018.737l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.08 -1018.606)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3393",
    "data-name": "Path 3393",
    d: "M1633.9,1018.742l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.126 -1018.609)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3394",
    "data-name": "Path 3394",
    d: "M1633.968,1018.746l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1631.173 -1018.612)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3395",
    "data-name": "Path 3395",
    d: "M1634.037,1018.751l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.219 -1018.615)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3396",
    "data-name": "Path 3396",
    d: "M1634.106,1018.755l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.265 -1018.618)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3397",
    "data-name": "Path 3397",
    d: "M1634.175,1018.76l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1631.311 -1018.622)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3398",
    "data-name": "Path 3398",
    d: "M1634.244,1018.765l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.358 -1018.625)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3399",
    "data-name": "Path 3399",
    d: "M1634.313,1018.769l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.404 -1018.628)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3400",
    "data-name": "Path 3400",
    d: "M1634.382,1018.774l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.45 -1018.631)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3401",
    "data-name": "Path 3401",
    d: "M1634.451,1018.779l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.496 -1018.634)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3402",
    "data-name": "Path 3402",
    d: "M1634.52,1018.783l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1631.542 -1018.637)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3403",
    "data-name": "Path 3403",
    d: "M1634.589,1018.788l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.589 -1018.64)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3404",
    "data-name": "Path 3404",
    d: "M1634.658,1018.792l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1631.635 -1018.643)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3405",
    "data-name": "Path 3405",
    d: "M1634.727,1018.8l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.681 -1018.646)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3406",
    "data-name": "Path 3406",
    d: "M1634.8,1018.8l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.727 -1018.649)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3407",
    "data-name": "Path 3407",
    d: "M1634.865,1018.806l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.773 -1018.653)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3408",
    "data-name": "Path 3408",
    d: "M1634.934,1018.811l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.819 -1018.656)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3409",
    "data-name": "Path 3409",
    d: "M1635,1018.816l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.866 -1018.659)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3410",
    "data-name": "Path 3410",
    d: "M1635.072,1018.82l-.107,2.053h-.023l.107-2.053Z",
    transform: "translate(-1631.912 -1018.662)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3411",
    "data-name": "Path 3411",
    d: "M1635.141,1018.825l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1631.958 -1018.665)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3412",
    "data-name": "Path 3412",
    d: "M1635.21,1018.829l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1632.005 -1018.668)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3413",
    "data-name": "Path 3413",
    d: "M1635.279,1018.834l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1632.051 -1018.671)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3414",
    "data-name": "Path 3414",
    d: "M1635.348,1018.839l-.107,2.053-.023,0,.107-2.053Z",
    transform: "translate(-1632.097 -1018.674)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3415",
    "data-name": "Path 3415",
    d: "M1635.108,1018.843l-.211.995-.07,1.047.152.01.107-2.053Z",
    transform: "translate(-1631.835 -1018.677)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3416",
    "data-name": "Path 3416",
    d: "M1635.491,1020.283l.048-.792h0Z",
    transform: "translate(-1632.28 -1019.112)",
    fill: "url(#linear-gradient-2)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10833",
    "data-name": "Group 10833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3417",
    "data-name": "Path 3417",
    d: "M1599.559,939.045s5.477-11.544,13.529-10.952a4.552,4.552,0,0,0-4.174-1.133c-2.571.578-9.9,5.274-11.372,11.95C1598.982,939.785,1599.559,939.045,1599.559,939.045Z",
    transform: "translate(-1592.488 -926.841)",
    fill: "url(#linear-gradient-397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3418",
    "data-name": "Path 3418",
    d: "M1588.165,960.566c-4.486-.164-5.265,5.37-5.265,5.37-1.255,3.85-.579,6.072.664,7.353a3.476,3.476,0,0,0,5.8-1.361c.337-1.049.672-2.042.839-2.384C1590.606,968.716,1592.651,960.73,1588.165,960.566Z",
    transform: "translate(-1582.231 -949.431)",
    fill: "url(#linear-gradient-398)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3419",
    "data-name": "Path 3419",
    d: "M1590.963,964.665a2,2,0,0,0-2.4.633c-3.984,5.3-1.776,9.912-.255,10.364,1.6.477,3.456-7.342,3.594-9.428A1.468,1.468,0,0,0,1590.963,964.665Z",
    transform: "translate(-1584.965 -952.068)",
    fill: "url(#linear-gradient-399)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10839",
    "data-name": "Group 10839",
    transform: "translate(514.127 362.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10837",
    "data-name": "Group 10837",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1658",
    "data-name": "Rectangle 1658",
    d: "M24.322,0H68.736A24.322,24.322,0,0,1,93.059,24.322v0A24.322,24.322,0,0,1,68.736,48.644H24.322A24.322,24.322,0,0,1,0,24.322v0A24.322,24.322,0,0,1,24.322,0Z",
    fill: "#f48a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3420",
    "data-name": "Path 3420",
    d: "M607.724,803.342l-17.868,1.506,27.978,31.778a.329.329,0,0,0,.56-.318Z",
    transform: "translate(-571.001 -760.437)",
    fill: "#f48a21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10838",
    "data-name": "Group 10838",
    transform: "translate(17.19 21.006)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 4.812,
    cy: 4.812,
    r: 4.812,
    transform: "translate(0 0)",
    fill: "#fff",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3421",
    "data-name": "Path 3421",
    d: "M667.622,741.814A4.812,4.812,0,1,1,662.811,737,4.812,4.812,0,0,1,667.622,741.814Z",
    transform: "translate(-633.839 -737.002)",
    fill: "#fff",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 4.812,
    cy: 4.812,
    r: 4.812,
    transform: "translate(48.32 0)",
    fill: "#fff",
    opacity: 0.84
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10842",
    "data-name": "Group 10842",
    transform: "translate(837.012 357.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10840",
    "data-name": "Group 10840",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1659",
    "data-name": "Rectangle 1659",
    d: "M24.322,0H68.736A24.322,24.322,0,0,1,93.059,24.322v0A24.322,24.322,0,0,1,68.736,48.644H24.322A24.322,24.322,0,0,1,0,24.322v0A24.322,24.322,0,0,1,24.322,0Z",
    fill: "url(#linear-gradient-400)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3422",
    "data-name": "Path 3422",
    d: "M1586.623,787.332l-17.868,1.506,27.978,31.778a.329.329,0,0,0,.559-.319Z",
    transform: "translate(-1549.645 -744.777)",
    fill: "url(#linear-gradient-401)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10841",
    "data-name": "Group 10841",
    transform: "translate(17.445 20.655)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    d: "M1573.332,725.8a4.811,4.811,0,1,1-4.811-4.812A4.811,4.811,0,0,1,1573.332,725.8Z",
    transform: "translate(-1563.709 -720.992)",
    fill: "#fff",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    d: "M1646.52,725.8a4.812,4.812,0,1,1-4.812-4.812A4.812,4.812,0,0,1,1646.52,725.8Z",
    transform: "translate(-1612.737 -720.992)",
    fill: "#fff",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    d: "M1719.709,725.8a4.812,4.812,0,1,1-4.812-4.812A4.812,4.812,0,0,1,1719.709,725.8Z",
    transform: "translate(-1661.766 -720.992)",
    fill: "#fff",
    opacity: 0.84
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10845",
    "data-name": "Group 10845",
    transform: "translate(588.856 383.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10843",
    "data-name": "Group 10843"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1660",
    "data-name": "Rectangle 1660",
    width: 93.059,
    height: 48.644,
    rx: 24.322,
    stroke: "#f6faff",
    strokeWidth: 1,
    fill: "url(#linear-gradient-402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    d: "M903.621,867.381l17.868,1.506-27.978,31.778a.329.329,0,0,1-.56-.319Z",
    transform: "translate(-848.76 -824.486)",
    fill: "url(#linear-gradient-403)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10844",
    "data-name": "Group 10844",
    transform: "translate(16.451 20.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    "data-name": "Path 3427",
    d: "M955.328,805.854a4.812,4.812,0,1,0,4.812-4.812A4.812,4.812,0,0,0,955.328,805.854Z",
    transform: "translate(-907.008 -801.042)",
    fill: "#fff",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    "data-name": "Path 3428",
    d: "M882.139,805.854a4.812,4.812,0,1,0,4.812-4.812A4.812,4.812,0,0,0,882.139,805.854Z",
    transform: "translate(-857.979 -801.042)",
    fill: "#fff",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    "data-name": "Path 3429",
    d: "M808.951,805.854a4.811,4.811,0,1,0,4.812-4.812A4.811,4.811,0,0,0,808.951,805.854Z",
    transform: "translate(-808.951 -801.042)",
    fill: "#fff",
    opacity: 0.84
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10848",
    "data-name": "Group 10848",
    transform: "translate(901.361 389.077)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10846",
    "data-name": "Group 10846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    "data-name": "Path 3430",
    d: "M1800.359,776.379c0-12.156-11.015-21.855-24.6-21.855H1730.4c-13.587,0-24.6,9.7-24.6,21.855h0c0,12.156,11.015,21.855,24.6,21.855h45.359c13.587,0,24.6-9.7,24.6-21.855Z",
    transform: "translate(-1705.797 -754.524)",
    fill: "#f48a21",
    stroke: "#f6faff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3431",
    "data-name": "Path 3431",
    d: "M1854.895,871.926l18.195,1.372-28.489,28.95a.363.363,0,0,1-.417.062.286.286,0,0,1-.153-.353Z",
    transform: "translate(-1798.388 -833.171)",
    fill: "url(#linear-gradient-404)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10847",
    "data-name": "Group 10847",
    transform: "translate(17.396 18.805)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 4.9,
    cy: 4.383,
    rx: 4.9,
    ry: 4.383,
    transform: "translate(49.203)",
    fill: "#fff",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    cx: 4.9,
    cy: 4.383,
    rx: 4.9,
    ry: 4.383,
    transform: "translate(24.602)",
    fill: "#fff",
    opacity: 0.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 4.9,
    cy: 4.383,
    rx: 4.9,
    ry: 4.383,
    fill: "#fff",
    opacity: 0.84
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10851",
    "data-name": "Group 10851",
    transform: "translate(684.255 274.631)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10849",
    "data-name": "Group 10849",
    transform: "translate(0 41.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    "data-name": "Path 3432",
    d: "M1093.361,628.309a2.126,2.126,0,0,1-1.959-1.3l-3.071-7.309a39.246,39.246,0,0,1-10.6-3.6l-6.888,3.936a2.126,2.126,0,0,1-2.454-.246l-7.851-6.881a2.125,2.125,0,0,1-.567-2.4l3-7.345a39.243,39.243,0,0,1-4.957-10.033l-7.649-2.086a2.126,2.126,0,0,1-1.561-1.911l-.687-10.416a2.127,2.127,0,0,1,1.3-2.1l7.31-3.072a39.258,39.258,0,0,1,3.6-10.6l-3.936-6.889a2.124,2.124,0,0,1,.247-2.455l6.879-7.851a2.126,2.126,0,0,1,2.4-.566l7.345,3a39.257,39.257,0,0,1,10.033-4.957l2.086-7.649a2.128,2.128,0,0,1,1.909-1.561l10.418-.686a2.13,2.13,0,0,1,2.1,1.3l3.071,7.309a39.248,39.248,0,0,1,10.6,3.6l6.888-3.936a2.127,2.127,0,0,1,2.455.246l7.852,6.881a2.125,2.125,0,0,1,.567,2.4l-3,7.346a39.251,39.251,0,0,1,4.957,10.033l7.649,2.086a2.126,2.126,0,0,1,1.561,1.911l.686,10.416a2.125,2.125,0,0,1-1.3,2.1l-7.309,3.072a39.242,39.242,0,0,1-3.6,10.6l3.936,6.889a2.126,2.126,0,0,1-.247,2.455l-6.88,7.851a2.123,2.123,0,0,1-2.4.566l-7.345-3a39.263,39.263,0,0,1-10.033,4.957l-2.086,7.649a2.126,2.126,0,0,1-1.909,1.561l-10.418.686C1093.454,628.308,1093.408,628.309,1093.361,628.309Zm-15.683-15.424.687.366a36.449,36.449,0,0,0,11.2,3.8l.767.127,3.479,8.278,9.427-.621,2.363-8.664.744-.227a36.449,36.449,0,0,0,10.6-5.238l.633-.453,8.319,3.4,6.227-7.106-4.458-7.8.366-.687a36.447,36.447,0,0,0,3.8-11.2l.127-.768,8.278-3.479-.621-9.427-8.664-2.363-.227-.744a36.442,36.442,0,0,0-5.238-10.6l-.453-.633,3.4-8.319-7.105-6.227-7.8,4.458-.687-.366a36.452,36.452,0,0,0-11.2-3.8l-.767-.127-3.479-8.278-9.427.621-2.363,8.664-.745.227a36.452,36.452,0,0,0-10.6,5.238l-.633.453-8.319-3.4-6.227,7.106,4.458,7.8-.366.687a36.441,36.441,0,0,0-3.8,11.2l-.127.768-8.278,3.479.621,9.428,8.663,2.363.227.745a36.445,36.445,0,0,0,5.238,10.6l.453.633-3.4,8.319,7.106,6.227Zm18.036-5.645a26.557,26.557,0,0,1-3.888-.284,1.41,1.41,0,1,1,.412-2.789,23.776,23.776,0,1,0-16.066-10,1.41,1.41,0,1,1-2.318,1.606,26.6,26.6,0,1,1,23.629,11.41Q1096.6,607.241,1095.714,607.241Z",
    transform: "translate(-1048.113 -533.331)",
    fill: "#91b3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3433",
    "data-name": "Path 3433",
    d: "M1170.288,666.193a10.695,10.695,0,1,1,3.3-.525h0A10.71,10.71,0,0,1,1170.288,666.193Zm.021-18.547a7.861,7.861,0,1,0,2.412,15.34h0a7.862,7.862,0,0,0-2.412-15.34Z",
    transform: "translate(-1122.811 -608.02)",
    fill: "#91b3fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10850",
    "data-name": "Group 10850",
    transform: "translate(70.788 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    d: "M1290.454,453.014a1.4,1.4,0,0,1-1.078-.506l-2.306-2.779a19.268,19.268,0,0,1-5.081-.166l-2.481,2.626a1.4,1.4,0,0,1-1.6.314l-4.573-2.069a1.4,1.4,0,0,1-.818-1.4l.335-3.6a19.251,19.251,0,0,1-3.479-3.707l-3.608.1a1.412,1.412,0,0,1-1.35-.905l-1.772-4.7a1.4,1.4,0,0,1,.415-1.572l2.779-2.306a19.254,19.254,0,0,1,.165-5.081l-2.626-2.481a1.4,1.4,0,0,1-.314-1.6l2.069-4.574a1.4,1.4,0,0,1,1.406-.818l3.6.335a19.254,19.254,0,0,1,3.707-3.479l-.1-3.609a1.4,1.4,0,0,1,.907-1.351l4.7-1.77a1.4,1.4,0,0,1,1.573.417l2.3,2.777a19.269,19.269,0,0,1,5.081.166l2.481-2.626a1.4,1.4,0,0,1,1.6-.314l4.573,2.069a1.4,1.4,0,0,1,.818,1.406l-.335,3.6a19.24,19.24,0,0,1,3.479,3.707l3.608-.1a1.4,1.4,0,0,1,1.351.907l1.77,4.7a1.4,1.4,0,0,1-.418,1.575l-2.776,2.3a19.272,19.272,0,0,1-.165,5.081l2.626,2.48a1.4,1.4,0,0,1,.314,1.6l-2.069,4.574a1.394,1.394,0,0,1-1.406.818l-3.6-.335a19.261,19.261,0,0,1-3.707,3.479l.1,3.607a1.4,1.4,0,0,1-.907,1.353l-4.7,1.77A1.4,1.4,0,0,1,1290.454,453.014Zm-2.5-5.525,2.719,3.277,3.746-1.412-.121-4.256.484-.325a17.154,17.154,0,0,0,4.059-3.807l.355-.463,4.242.4,1.65-3.648-3.1-2.925.113-.572a17.166,17.166,0,0,0,.181-5.562l-.076-.579,3.276-2.719-1.412-3.746-4.256.121-.325-.485a17.155,17.155,0,0,0-3.807-4.059l-.463-.355.395-4.242-3.647-1.65-2.925,3.1-.573-.113a17.154,17.154,0,0,0-5.562-.181l-.579.076-2.719-3.277-3.745,1.412.121,4.256-.485.325a17.165,17.165,0,0,0-4.058,3.808l-.356.463-4.242-.395-1.65,3.648,3.1,2.925-.113.573a17.135,17.135,0,0,0-.181,5.562l.076.579-3.277,2.719,1.412,3.746,4.256-.121.326.485a17.152,17.152,0,0,0,3.807,4.058l.463.356-.395,4.242,3.647,1.65,2.926-3.1.573.113a17.168,17.168,0,0,0,5.562.181Zm-9.176,3.088h0Zm15.655-.715v0Zm-28.73-10.149h0Zm-1.084-4.237v0Zm41.046-10.109v0Zm.212-.8,0,0Zm-14.371-14.3h0Zm-4.552,33.1a1.058,1.058,0,0,1-.155-2.1,11.059,11.059,0,1,0-11.968-7.04,11.037,11.037,0,0,0,3.469,4.759,1.058,1.058,0,0,1-1.313,1.658,13.151,13.151,0,1,1,10.125,2.714A1.065,1.065,0,0,1,1286.959,443.365Z",
    transform: "translate(-1262.554 -407.829)",
    fill: "#91b3fa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10852",
    "data-name": "Group 10852",
    transform: "translate(813.004 571.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M1438.135,1355.037v-4.949l5.081-4.685c10.1-9.37,14.847-14.517,14.913-20.192,0-3.827-2.046-7.193-7.655-7.193-3.761,0-6.994,1.914-9.172,3.563l-2.375-5.741a21.227,21.227,0,0,1,13.2-4.421c9.5,0,14.121,6,14.121,13,0,7.522-5.411,13.593-12.867,20.521l-3.761,3.233v.132h17.618v6.73Z",
    transform: "translate(-1438.135 -1309.836)",
    fill: "url(#linear-gradient-405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M1560.083,1356.51v-10.888h-19.4v-5.279l17.486-26.724h9.568v25.866h5.543v6.136h-5.543v10.888Zm0-17.024v-11.679c0-2.442.066-4.949.264-7.456h-.264c-1.32,2.706-2.441,4.883-3.761,7.258l-7.853,11.746-.066.132Z",
    transform: "translate(-1506.831 -1311.309)",
    fill: "url(#linear-gradient-405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3437",
    "data-name": "Path 3437",
    d: "M1645.429,1354.462l16.1-47.84h5.675l-16.1,47.84Z",
    transform: "translate(-1577 -1306.622)",
    fill: "url(#linear-gradient-405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3438",
    "data-name": "Path 3438",
    d: "M1750.624,1313.619v5.213l-18.146,37.678H1723.9l18.08-36.028v-.132h-20.191v-6.731Z",
    transform: "translate(-1628.153 -1311.309)",
    fill: "url(#linear-gradient-405)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10853",
    "data-name": "Group 10853",
    transform: "translate(751.827 571.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3439",
    "data-name": "Path 3439",
    d: "M1276.749,1353.737a23.94,23.94,0,1,1,23.94-23.941A23.968,23.968,0,0,1,1276.749,1353.737Zm0-45.766a21.825,21.825,0,1,0,21.825,21.825A21.85,21.85,0,0,0,1276.749,1307.971Z",
    transform: "translate(-1252.809 -1305.856)",
    fill: "url(#linear-gradient-405)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3440",
    "data-name": "Path 3440",
    d: "M1334.743,1355.289a1.055,1.055,0,0,1-.752-.314l-10.759-10.888a1.057,1.057,0,0,1-.305-.743v-16.478a1.057,1.057,0,0,1,2.115,0v16.043l10.453,10.579a1.057,1.057,0,0,1-.752,1.8Z",
    transform: "translate(-1299.78 -1319.222)",
    fill: "url(#linear-gradient-405)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitmentToServe);
export default __webpack_public_path__ + "static/media/commitment-to-serve.0332e558ed0028b9362b090b571fdc4b.svg";
export { ForwardRef as ReactComponent };